export default __webpack_public_path__ + "static/media/sf-mobile-detail.948d7034.png";